import { Injectable, Injector } from '@angular/core';
import { FormationTtype } from '../entities/formationTtype';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class FormationTtypeService extends BaseCrudService<FormationTtype> {

  public uri = '/api/formationTtype/';

  constructor(injector: Injector) {
      super(injector);
     //console.log('Instance FormationTtypeService');
  }

  buildSentence(entity?: FormationTtype, event?: LazyLoadEvent): HttpParams {
      if (entity) {
          let query = entity.code ? 'code'
              + QueryOperator.Contain + entity.code
              + QueryOperator.Split : QueryOperator.Empty;
          query = query.concat(
              entity.name ? 'name'
              + QueryOperator.Contain + entity.name
              + QueryOperator.Split : QueryOperator.Empty
          );
          this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
      }

      if (event) {
          const page = ((event.first + event.rows) / event.rows - 1 ).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
      }
      return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/formation-ttype.service.ts